import { useState } from 'react';
import MetricsCsvService from '@avtechsoftware/ra-javascript-utilities/src/utilities/metricsGroups/MetricsCsvService';
import envConfig from '../../../envConfig';
import { sessionHash } from '../../../utility/remoteServiceUtil';

const useFetchChannelKeyGraphData = () => {
  const [graphData, setGraphData] = useState({
    data: [], toGraph: [], startTime: 0, endTime: 0,
  });

  const authToken = sessionHash;

  const fetchGraphData = async (channelKeys, startTime, endTime) => {
    const formattedChannelKeys = Array.isArray(channelKeys)
      ? channelKeys.join(',')
      : channelKeys; // ← supports single or list without changing API

    const data = [];

    try {
      const startTimeSeconds = Math.ceil(startTime / 1000);
      const endTimeSeconds = Math.ceil(endTime / 1000);
      const reportDataUrlBase = `${envConfig.apiUrl}/api/v1/device-data/device/samples/find-by-channel-keys`;

      const response = await MetricsCsvService.loadCsvData(
        `${reportDataUrlBase}?auth_token=${authToken}`
          + `&channelKeys=${formattedChannelKeys}`
          + `&startTime=${startTimeSeconds}`
          + `&endTime=${endTimeSeconds}`
          + '&sampleTimeRangeAggregateTypeId=1',
        (row) => row,
      );

      // response rows contain values for all requested channelKeys
      // flatten all readings into a single array just like original code
      const keyList = Array.isArray(channelKeys) ? channelKeys : [channelKeys];

      response.forEach((reading) => {
        const ts = reading.Date * 1000;
        keyList.forEach((key) => {
          const raw = reading[key];
          if (raw !== undefined && raw !== null && raw !== '') {
            const value = Number(raw);
            if (!Number.isNaN(value)) {
              data.push({ timestamp: ts, value, channelKey: key });
            }
          }
        });
      });

      setGraphData({
        originalData: data,
        toGraph: data,
        startTime,
        endTime,
      });
    } catch (error) {
      setGraphData({
        originalData: [],
        toGraph: [],
        startTime,
        endTime,
      });
    }
  };

  return {
    graphData,
    setGraphData,
    fetchGraphData,
  };
};

export default useFetchChannelKeyGraphData;
